import MD5 from '@/services/MD5';

// From https://github.com/Bitstrips/monorepo/blob/143d53663ef33f1d580ad6c0aaedcd7679cba196/bitmoji_api/src/plugins/experiments/services/experiments_service.js#L82-L110
const normalizedHash = (shuffleKey: string, uuid: string): number => {
  // @ts-ignore
  const tempHash = MD5.md5(shuffleKey + uuid);
  const slicedTempHash = tempHash.slice(0, 8); // 32-bit is enough for us
  const decimalHash = parseInt(slicedTempHash, 16); // convert hexademical
  return decimalHash / Math.pow(2, 32); // normalize to [0, 1)
};

// From https://github.com/Bitstrips/monorepo/blob/143d53663ef33f1d580ad6c0aaedcd7679cba196/bitmoji_api/src/plugins/experiments/services/experiments_service.js#L82-L110
const biasedHashPick = (shuffleKey: string, uuid: string, ratios: number[]): number | null => {
  if (!shuffleKey) {
    return null;
  }

  const uuidNormalizedHash = normalizedHash(shuffleKey, uuid);

  // Find the first index where cumulative mass is larger than the normalized value
  let idx = 0;
  let sum = 0;
  for (; idx < ratios.length; ++idx) {
    sum += ratios[idx];
    if (sum >= uuidNormalizedHash) {
      return idx;
    }
  }

  return null;
};

class FeatureGates {
  // Takes a shuffleKey unique to a given gate, and a percentage that the gate should be open.
  // Returns true if the gate is open for this user's device.
  //   - percentage = 0.0 is disabled for everyone.
  //   - percentage = 1.0 is enabled for everyone.
  gate(shuffleKey: string, percentage: number): boolean {
    const groups = [percentage, 1.0];
    const groupIdx = biasedHashPick(shuffleKey, this.getUserStr(), groups);
    return groupIdx === 0;
  }

  // Gets the user device identifier (userAgent + other things) from the environment.
  //
  getUserStr(): string {
    return (navigator && navigator.userAgent) + (navigator && navigator.vendor);
  }

  promosEnabledInProduction = this.gate('promosEnabled', 1.0);
  updatedTraitNavEnabledInProduction = this.gate('updatedTraitNavEnabled', 0.0);
  highlightedUndoRedoInProduction = this.gate('highlightedUndoRedoEnabled', 0.0);
  useAssetsServiceInProduction = this.gate('useAssetsService', 1.0);
}

export default new FeatureGates();
